import React from 'react';
import Form from 'react-bootstrap/Form';

const validationMessages = {
  memberNumber: 'Invalid account number',
  reenter: "Password doesn't match",
  email: 'Invalid email address',
  phone: 'Invalid phone number',
  password: 'Invalid password',
};

export const InvalidFeedback = ({ type }) => (
  <Form.Control.Feedback type="invalid">{validationMessages[type]}</Form.Control.Feedback>
);
